// extracted by mini-css-extract-plugin
var _1 = "t2LE";
var _2 = "t2LF";
var _3 = "t2LD";
export { _1 as "error", _2 as "input", _3 as "spinner" }
